import { Dispatch, SetStateAction } from 'react';
import styled from 'styled-components';
import {
  ButtonTertiary,
  cssSpacing,
  PopoverOnboarding,
  Type,
} from '@spotify-internal/encore-web';
import { useT } from '@spotify-internal/i18n-core';

const StyledPopoverOnboarding = styled(PopoverOnboarding)`
  position: absolute;
  margin-top: ${cssSpacing('base', '24px')};
  z-index: 1;
`;

interface OnboardingPopoverOneProps {
  setOnboardingStep: Dispatch<SetStateAction<number | null>>;
  onComplete: () => void;
}

export const OnboardingPopoverOne = ({
  setOnboardingStep,
  onComplete,
}: OnboardingPopoverOneProps) => {
  const t = useT();

  return (
    <StyledPopoverOnboarding
      data-testid="onboarding"
      id="onboardingStepOne"
      arrow="topStart"
      popoverTitle={t(
        'atlas.catalog_exports.walk_through.choose_your_export_type',
        'Choose your export type',
        'Title of walkthrough popover',
      )}
      colorSet="mutedAccent"
      onClose={() => onComplete()}
      onClick={(event: React.MouseEvent) => {
        event.preventDefault();
        event.stopPropagation();
      }}
      paginationText={
        <Type as="p" semanticColor="textSubdued" variant="finale">
          {t(
            'atlas.walk_through.one_of_three',
            '1 of 3',
            'Indicates this is one of three directions. 1 and 3 should be kept as numbers',
          )}
        </Type>
      }
      footerButton={
        <ButtonTertiary
          condensed
          size="small"
          onClick={() => {
            setOnboardingStep(2);
          }}
        >
          {t('atlas.actions.next', 'Next', 'Button text to go to next step')}
        </ButtonTertiary>
      }
    >
      {t(
        'atlas.catalog_exports.walk_through.choose_btwn_albums_or_tracks',
        'Choose between albums or tracks for the content of your export.',
        'Text in walkthrough popover',
      )}
    </StyledPopoverOnboarding>
  );
};
